import cookie from 'cookie-machine';

const initialState = {
  position: {
      coords:{
        latitude: 0,
        longitude: 0
      }
  }
}

const geolocation = (state = initialState, action) => {
   switch (action.type) {

      case 'RECIEVE_POSITION':
        
        cookie.set("latitude", action.position.coords.latitude);
        cookie.set("longitude", action.position.coords.longitude);
        

         return {
        ...state,
        position: action.position
      }
      
    default:
      return state;
  }
  
}

export default geolocation



// WEBPACK FOOTER //
// ./src/reducers/geolocation.js